// ActionHandler — receives toolbar actions (and keyboard shortcuts that
// alias to toolbar actions) and dispatches to the corresponding
// Document mutation. Symbol names match the `data-house-md-action`
// values emitted by Toolbar.

import { UploadStarter } from "./upload.js"

export class ActionHandler {
  constructor(document) {
    this.document = document
  }

  handleAction(name, detail) {
    const handler = this[name]
    if (!handler) {
      console.error("Not handling:", name)
      return
    }
    handler.call(this, detail)
  }

  bold() { this.document.toggleBold() }
  italic() { this.document.toggleItalic() }
  strikethrough() { this.document.toggleStrikethrough() }
  quote() { this.document.toggleQuote() }
  code() { this.document.toggleCode() }
  link() { this.document.toggleLink() }
  bulletList() { this.document.toggleBulletList() }
  numberList() { this.document.toggleNumberList() }
  undo() { this.document.undo() }
  redo() { this.document.redo() }

  uploadFile({ file }) {
    new UploadStarter(this.document.element, file).upload()
  }
}
